import React from "react";
import clsx from "clsx";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ScaleLoader } from "react-spinners";

/*
This class wraps other types of charts and provides some useful UI components like
consistent loading, titles, and a hamburger menu.

However, it makes assumptions about aspect ratio that help when many charts are stacked in a grid,
but might be undesirable. Use at your own discretion!
*/
export default function ChartContainer({
  title,
  className,
  children,
  loading,
  loadingColor,
  action,
  hideMenu,
}) {
  return (
    <div className="chart-container">
      {!hideMenu && (
        <span className="top-right">
          <div
            className="rounded-icon-container gray-text"
            onClick={() => {
              action();
            }}
          >
            <FontAwesomeIcon icon={faEllipsisV} />
          </div>
        </span>
      )}
      <div className="graph-title">
        <span>{title}</span>
      </div>
      <div className={clsx("custom-chart-container", className)}>
        <div>
          <div className="dummy" />
          <div className={clsx("contents", loading && "flex-container")}>
            {loading ? (
              <div className="flex-container">
                <ScaleLoader
                  width={"2px"}
                  height={"30px"}
                  color={loadingColor ? loadingColor : "#62cb88"}
                  loading={true}
                />
              </div>
            ) : (
              children
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
